import { baseUrl } from "../config/app.config";
import axios from "axios";
import { async } from "q";
export const areaBranchTeamService = async () => {
  let result = { error: false, data: "" };

  try {
    
    var response = await axios.get(
      baseUrl + "/api/Users/getAreaTeamOfficeOfUser"
    );

    result.data = response.data;
  } catch (error) {
    
    result.error = true;
    result.data = null;
  }
  
  return result.data;
};

export const getAllAreaTeamBranch = async () => {
  let result = { error: false, data: [] };

  try {
    var response = await axios.get(
      baseUrl + "/api/Users/getAllAreaTeamOfficeOfUser"
    );

    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const getEmployeeAreaTeamOfficeList = async employeeId => {
  let result = { error: false, data: [] };

  try {
    var response = await axios.get(
      baseUrl +
        "/api/Users/getEmployeeAreaTeamOfficeList?employeeId=" +
        employeeId
    );

    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const InsertEmployeeAreaTeamOffice = async employeeAreaTeamOffice => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/Users/InsertEmployeeAreaTeamOffice",
      data: employeeAreaTeamOffice
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const DeleteEmployeeAreaTeamOffice = async employeeAreaTeamOffice => {
  let result = { error: false, data: "" };
  try {
    var response = await axios({
      method: "DELETE",
      url: baseUrl + "/api/Users/DeleteEmployeeAreaTeamOffice",
      data: employeeAreaTeamOffice
    });
    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }

  return result;
};
